import { get } from 'lodash';
import { isGroup } from 'utils/nodeTypes';

export default function updateQuestionFavoriteHandler(state, action) {
  const { questionRefId, isFavorite } = action?.payload || {};
  const previousNodes = get(state, 'surveyDetailsExtended.questions', []);

  const lookupAndUpdate = (node) => {
    if (node.refId === questionRefId) {
      return { ...node, isFavorite };
    }
    if (isGroup(node)) {
      return {
        ...node,
        questions: node.questions.map(lookupAndUpdate),
      };
    }
    return node;
  };
  const newNodes = previousNodes.map(lookupAndUpdate);
  return Object.assign({}, state, {
    surveyDetailsExtended: {
      ...state.surveyDetailsExtended,
      questions: newNodes,
    },
  });
}
